import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import Select from "react-select";
import ClipLoader from "react-spinners/ClipLoader";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import biometric from "../../../Assets/Images/biometric.svg";
import gps from "../../../Assets/Images/gps.svg";
import qr from "../../../Assets/Images/qr-code.svg";
import rightimg from "../../../Assets/Images/right.svg";
import selfie from "../../../Assets/Images/selfie-img.svg";
import PaginationTab from "../../../components/PaginationTab";
import SearchStaff from "../../../components/SearchStaff";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";
import { HeaderSkeleton, PaginationSkeleton, TableSkeleton } from "./StaffTab";

const AttendanceTab = () => {
  const {
    baseUrl,
    openToast,
    staffs,
    fetchStaffs,
    fetchDepartments,
    isLoading,
    setSelectedStaff,
    selectedStaffIds,
    setSelectedStaffIds,
    selectAll,
    setSelectAll,
    loadingStaffs,
  } = useGlobalContext();
  console.log(staffs)
  const handleMonthChange = (e) => {
    setSelectedMonth(new Date(e.target.value));
  };

  const toggleAccordion = () => {
    setIsOpen((isOpen) => !isOpen);
  };

  const handleWeekoffToggle = (e) => {
    if (e.target.checked) {
      // Get all Sundays of the selected month
      const sundays = [];
      const year = selectedMonth.getFullYear();
      const month = selectedMonth.getMonth();

      for (let day = 1; day <= 31; day++) {
        const date = new Date(year, month, day);
        if (date.getMonth() !== month) break; // Stop if next month starts
        if (date.getDay() === 0) {
          // Check for Sunday
          sundays.push({
            day: date.toISOString(),
            weekOff: true,
            shifts: [],
          });
        }
      }

      // Merge with existing flexibleDay data
      setFlexibleDay((prev) => {
        const nonSundays = prev.filter(
          (item) => new Date(item.day).getDay() !== 0
        );
        return [...nonSundays, ...sundays];
      });
    } else {
      // If unchecked, remove all Sundays from weekOff
      setFlexibleDay((prev) =>
        prev.filter((item) => new Date(item.day).getDay() !== 0)
      );
    }
  };

  const [toggleDrop, setToggleDrop] = useState(false);
  const [selectShiftType, setSelectShiftType] = useState("Fixed");
  const dropdownRef = useRef(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  // loader when calling api on submitting shifts Bulk Update Work Timings for All Staff
  const [isShiftSubmission, setIsShiftSubmission] = useState(false);
  // loader for flexible shift creation
  const [isFlexibleShiftCreating, setIsFlexibleShiftCreating] = useState(false);

  const staffDropDown = useRef(null);

  function handledrop() {
    setToggleDrop(!toggleDrop);
  }
  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    if (!staffs) {
      fetchStaffs();
      fetchDepartments();
    }
  }, []);

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
    if (staffDropDown.current && !staffDropDown.current.contains(e.target)) {
      setToggleDrop(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (staffs) {
      setSelectAll(
        staffs?.length > 0 && selectedStaffIds.length === staffs.length
      );
    }
  }, [selectedStaffIds, staffs]);

  const customStyles = {
    content: {
      top: "50%",
      left: "55%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "40%",
      padding: "0",
      borderRadius: "10px",
    },
  };

  let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal() {
    setSelectShiftType("Fixed");
    setIsOpen(false);
  }

  const [modalIsOpen1, setIsOpen1] = React.useState(false);
  function openModal1() {
    setIsOpen1(true);
  }
  function afterOpenModal1() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal1() {
    setIsOpen1(false);
  }

  const [modalIsOpen2, setIsOpen2] = React.useState(false);
  function openModal2() {
    setIsOpen2(true);
  }
  function afterOpenModal2() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal2() {
    setIsOpen2(false);
  }

  // onclick start timing

  const [modalIsOpen3, setIsOpen3] = React.useState(false);
  function openModal3() {
    setIsOpen3(true);
  }
  function afterOpenModal3() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal3() {
    setIsOpen3(false);
  }
  // onclick start timing

  // onclick end timing

  const [modalIsOpen4, setIsOpen4] = React.useState(false);
  function openModal4() {
    setIsOpen4(true);
  }
  function afterOpenModal4() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal4() {
    setIsOpen4(false);
  }
  // onclick end timing

  //  onclick auto half day button

  const [modalIsOpen16, setIsOpen16] = React.useState(false);
  function openModal16() {
    setIsOpen16(true);
  }
  function afterOpenModal16() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal16() {
    setIsOpen16(false);
  }
  // onclick auto half day button

  // onclick mandatory half day button
  const [modalIsOpen17, setIsOpen17] = React.useState(false);
  function openModal17() {
    setIsOpen17(true);
  }
  function afterOpenModal17() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal17() {
    setIsOpen17(false);
  }
  // onclick mandatory half day button

  // onclick mandatory full day button
  const [modalIsOpen18, setIsOpen18] = React.useState(false);
  function openModal18() {
    setIsOpen18(true);
  }
  function afterOpenModal18() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal18() {
    setIsOpen18(false);
  }
  // onclick mandatory half day button

  // onclick update attendance
  const [modalIsOpen5, setIsOpen5] = React.useState(false);
  function openModal5() {
    setIsOpen5(true);
  }
  function afterOpenModal5() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal5() {
    setIsOpen5(false);
  }

  // onclick update attendance

  // toggle switch
  const [isOn, setIsOn] = useState(false);

  const handleToggle = () => {
    setIsOn(!isOn);
  };
  // toggle switch
  const [isOnSelfie, setIsOnSelfie] = useState(false);
  const selfieAttendance = () => {
    setIsOnSelfie(!isOnSelfie);
  };
  const [qrCode, setQrCode] = useState(false);
  const qrAttendance = () => {
    setQrCode(!qrCode);
  };
  const [gpsCode, setGpsCode] = useState(false);
  const gpsAttendance = () => {
    setGpsCode(!gpsCode);
  };

  const [autoPresent, setAutoPresent] = useState(false);
  const autoPresentFn = () => {
    setAutoPresent(!autoPresent);
  };
  const [presentPunch, setPresentPunch] = useState(false);
  const PresentPunchFn = () => {
    setPresentPunch(!presentPunch);
  };

  // toggle switch

  {
    /* when onclick update attendance modes for all staff */
  }
  const [modalIsOpen6, setIsOpen6] = React.useState(false);
  function openModal6() {
    setIsOpen6(true);
  }
  function afterOpenModal6() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal6() {
    setIsOpen6(false);
  }

  {
    /* when onclick update attendance modes for all staff */
  }

  {
    /* when onclick update automation rule for all staff */
  }
  const [modalIsOpen7, setIsOpen7] = React.useState(false);
  function openModal7() {
    setIsOpen7(true);
  }
  function afterOpenModal7() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal7() {
    setIsOpen7(false);
  }

  {
    /* when onclick update automation rule for all staff */
  }

  {
    /* when onclick update attendance modes  rule for all staff  successfull message*/
  }

  const [modalIsOpen8, setIsOpen8] = React.useState(false);
  function openModal8() {
    setIsOpen8(true);
  }
  function afterOpenModal8() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal8() {
    setIsOpen8(false);
  }

  {
    /* when onclick update attendance modes  rule for all staff  successfull message*/
  }
  const [shiftName, setShiftName] = useState();
  const [shiftStartTime, setShiftStartTime] = useState();
  const [shiftEndTime, setShiftEndTime] = useState();
  const [punchInType, setPunchInType] = useState("ANYTIME");
  const [punchOutType, setPunchOutType] = useState("ANYTIME");
  const [allowPunchInHour, setAllowPunchInHour] = useState();
  const [allowPunchInMinutes, setAllowPunchInMinutes] = useState();
  const [allowPunchOutMinutes, setAllowPunchOutMinutes] = useState();
  const [allowPunchOutHour, setAllowPunchOutHour] = useState();
  const [isUpdatingAutomation, setIsUpdatingAutomation] = useState(false);

  const handleTimeChange = (value) => {
    const [hours, minutes] = value.split(":").map(Number);

    // Determine AM or PM
    const period = hours >= 12 ? "PM" : "AM";

    // Convert to 12-hour format
    const adjustedHours = hours % 12 || 12; // `12` for midnight and noon
    const formattedTime = `${adjustedHours}:${minutes < 10 ? `0${minutes}` : minutes
      } ${period}`;

    return formattedTime;
  };

  async function submitShift() {
    setIsShiftSubmission(true);
    try {
      const result = await fetch(baseUrl + "shift", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          shiftName: shiftName,
          shiftStartTime: shiftStartTime,
          shiftEndTime: shiftEndTime,
          punchInType: punchInType,
          punchOutType: punchOutType,
          allowPunchInHours: allowPunchInHour,
          allowPunchInMinutes: allowPunchInMinutes,
          allowPunchOutHours: allowPunchOutHour,
          allowPunchOutMinutes: allowPunchOutMinutes,
        }),
      });
      if (result.status === 201) {
        const data = await result.json();
        openToast("Add Shift Successfully", "success");
        setIsShiftSubmission(false);
        closeModal2();
        fetchShiftDetails();
      } else {
        openToast("An Error Occured", "error");
      }
    } catch (error) {
      openToast("error while submitting shift" || error.message, "error");
    } finally {
      setIsShiftSubmission(false);
    }
  }

  const [shiftDetails, setShiftDetails] = useState();
  console.log(shiftDetails, "--------------------");

  async function fetchShiftDetails() {
    const result = await fetch(baseUrl + "shift", {
      headers: {
        Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
      },
    });
    if (result.status === 200) {
      const data = await result.json();
      setShiftDetails(data);
    } else {
      openToast("No Record Found");
    }
  }

  const [selectedShift, setSelectedShift] = useState([]);
  const isSelected = (shiftId) => selectedShift.some((s) => s.id === shiftId);

  // Handle checkbox change
  const handleCheckboxChange = (shift) => {
    setSelectedShift((prevSelected) => {
      if (isSelected(shift.id)) {
        // If already selected, remove from selectedShift
        return prevSelected.filter((s) => s.id !== shift.id);
      } else {
        // Otherwise, add to selectedShift
        return [...prevSelected, shift];
      }
    });
  };

  useEffect(() => {
    fetchShiftDetails();
  }, []);

  const [selectedOptions, setSelectedOptions] = useState([]);
  const options = selectedShift.map((seo) => ({
    value: seo.id,
    label: `${seo.shiftName} | ${seo.shiftStartTime} - ${seo.shiftEndTime}`,
  }));
  const [selectedId, setSelectedId] = useState([]);

  // console.log(selectedId);
  const handleUpdate = () => {
    // setSelectedId([]); // Call the first function
    openModal5(); // Call the second function
  };

  const [markAttendanceOffice, setMarkAttendanceOffice] = useState();

  const [isUpdatingAttendeceMode, setIsUpdatingAttendenceMode] =
    useState(false);
  async function updateDetails() {
    const data = {
      staff_ids: [...selectedId],
      attendence_mode: {
        selfie_attendance: isOnSelfie,
        qr_attendance: qrCode,
        gps_attendance: gpsCode,
        mark_attendance: markAttendanceOffice,
        allow_punch_in_for_mobile: isOn,
      },
    };

    setIsUpdatingAttendenceMode(true);
    try {
      const result = await fetch(baseUrl + "attendance/mode", {
        method: "PUT",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(data),
      });
      const res = await result.json();
      if (result.status == 200) {
        setIsUpdatingAttendenceMode(false);
        openToast(res.message || "Update Details Successfully", "success");
        openModal6();
      } else {
        openToast(res.message || "Internal Server Error", "error");
      }
    } catch (error) {
      if (error.message === "Failed to fetch") {
        openToast(
          "Unable to connect to the server. Please check your network or try again later.",
          "error"
        );
      } else {
        openToast("An unexpected error occurred. Please try again.", "error");
      }
    } finally {
      setIsUpdatingAttendenceMode(false);
    }
  }

  const handleUpdateAutoMation = () => {
    openModal7(); // Call the second function
  };

  const [time, setTime] = useState({ hours: "", minutes: "" });
  const [confirmedTime, setConfirmedTime] = useState(null); // Holds confirmed time values

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTime((prevTime) => ({
      ...prevTime,
      [name]: value,
    }));
  };

  const handleConfirm = () => {
    setConfirmedTime(time); // Set the confirmed values
    closeModal16(); // Open modal or any other action needed
  };

  const [duration, setDuration] = useState({ hrs: "", mins: "" }); // Renamed state
  const [savedDuration, setSavedDuration] = useState(null); // Renamed confirmed state

  const handleDurationChange = (e) => {
    const { name, value } = e.target;
    setDuration((prevDuration) => ({
      ...prevDuration,
      [name]: value,
    }));
  };

  const handleSaveDuration = () => {
    setSavedDuration(duration); // Save current values
    closeModal17(); // Open modal or any other action needed
  };

  const [selectedTime, setSelectedTime] = useState({
    hourValue: "",
    minuteValue: "",
  }); // New state names
  const [confirmedSelection, setConfirmedSelection] = useState(null); // New confirmed state name

  const handleTimeChangeSet = (e) => {
    const { name, value } = e.target;
    setSelectedTime((prevSelectedTime) => ({
      ...prevSelectedTime,
      [name]: value,
    }));
  };

  const handleSaveSelection = () => {
    setConfirmedSelection(selectedTime); // Save current values to confirmed selection
    closeModal18(); // Open the modal for showing confirmed time
  };



  const [isUpdatingAutomationDetails, setIsUpdatingAutomationDetails] =
    useState(false);
  async function updateAutomationDetail() {
    const data = {
      staff_ids: [...selectedId],
      automation_rules: {
        auto_absent: autoPresent,
        present_on_punch: presentPunch,
        auto_half_day: `${confirmedTime?.hours || 0} hours, ${confirmedTime?.minutes || 0} minutes`,
        mandatory_half_day: `${savedDuration?.hrs || 0} hours, ${savedDuration?.mins || 0} minutes`,
        mandatory_full_day: `${confirmedSelection?.hourValue || 0} hours, ${confirmedSelection?.minuteValue || 0} minutes`,
      },
    };
    setIsUpdatingAutomationDetails(true);
    try {
      const result = await fetch(baseUrl + "attendance/automation", {
        method: "PUT",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(data),
      });
      if (result.status === 200) {
        openToast("Update Details Successfully", "success");
        setIsUpdatingAutomationDetails(false);
        closeModal7();
      } else {
        openToast("Internal Server Error", "error");
      }
    } catch (error) {
      openToast(
        "error while updating automation details" || error.message,
        "error"
      );
    } finally {
      setIsUpdatingAutomationDetails(false);
    }
  }

  const [modalIsOpen22, setIsOpen22] = React.useState(false);
  function openModal22() {
    setIsOpen22(true);
  }
  function afterOpenModal22() {
    subtitle.style.color = "#000";
  }

  function closeModal22() {
    setIsOpen22(false);
  }

  const [allWeeksSelected, setAllWeeksSelected] = useState(false);
  const [weeks, setWeeks] = useState({
    firstWeek: false,
    secondWeek: false,
    thirdWeek: false,
    fourthWeek: false,
    fifthWeek: false,
  });
  const [selectedWeeks, setSelectedWeeks] = useState({
    Mon: "",
    Tue: "",
    Wed: "",
    Thu: "",
    Fri: "",
    Sat: "",
    Sun: "",
  }); // To store selected weeks
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal open/close state

  const handleAllWeeksToggle = () => {
    const newStatus = !allWeeksSelected;
    setAllWeeksSelected(newStatus);
    setWeeks({
      firstWeek: newStatus,
      secondWeek: newStatus,
      thirdWeek: newStatus,
      fourthWeek: newStatus,
      fifthWeek: newStatus,
    });
  };

  const handleWeekToggle = (week) => {
    const updatedWeeks = {
      ...weeks,
      [week]: !weeks[week],
    };
    setWeeks(updatedWeeks);

    // Check if all weeks are selected after this update
    const allSelected = Object.values(updatedWeeks).every(
      (selected) => selected
    );
    setAllWeeksSelected(allSelected);
  };

  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const handleCheckboxChange2 = () => {
    setIsCheckboxChecked((prev) => !prev);
  };
  const handleConfirm2 = () => {
    const selectedDay = weekName.slice(0, 3); // Extract day abbreviation (e.g., 'Mon', 'Tue')

    // Find the current day in the dayWiseWeekOff array
    const currentDay = dayWiseWeekOff.find((day) => day.day === selectedDay);

    // Check if all weeks are selected
    const allWeeksSelected = Object.values(weeks).every(
      (week) => week === true
    );

    if (currentDay) {
      // Filter out selected weeks (those that are true)
      const selectedWeek = Object.keys(weeks)
        .map((week, index) => {
          const weekIndex = index + 1; // Adjust for 1-based index
          const weekSuffix =
            weekIndex === 1
              ? "st"
              : weekIndex === 2
                ? "nd"
                : weekIndex === 3
                  ? "rd"
                  : "th";

          // Check if the week is selected (true) or not (false)
          return {
            weekIndex,
            weekSuffix,
            isSelected: weeks[week], // true or false based on whether the week is selected
          };
        })
        .filter(({ isSelected }) => isSelected) // Only keep selected weeks (true)
        .map(({ weekIndex, weekSuffix }) => {
          // Return the formatted week with the suffix
          return `${weekIndex}${weekSuffix}`;
        });

      // If all weeks are selected, set it to 'All Week Off'
      const weekOffText = allWeeksSelected
        ? `All ${weekName} Week Off`
        : selectedWeek.length > 0
          ? `${selectedWeek.join(", ")} Week is Off`
          : "";

      // Update selectedWeeks with the selected week(s)
      setSelectedWeeks((prevSelectedWeeks) => {
        // Find the index of the selectedDay in the current selectedWeeks object
        const selectedDayKey = selectedDay; // The key should be the abbreviation (e.g., "Mon")

        if (prevSelectedWeeks[selectedDayKey]) {
          // If the day is already in the selectedWeeks, update the week off info
          return {
            ...prevSelectedWeeks,
            [selectedDayKey]: weekOffText, // Update the info for that day
          };
        } else {
          // If the day isn't found in selectedWeeks, simply add it
          return {
            ...prevSelectedWeeks,
            [selectedDayKey]: weekOffText, // Add the entry
          };
        }
      });
    }

    // Update dayWiseWeekOff by finding the index of the selectedDay and updating the entry
    setDayWiseWeekOff((prevDayWiseWeekOff) => {
      // Find the index of the selectedDay in the current dayWiseWeekOff array
      const index = prevDayWiseWeekOff.findIndex(
        (day) => day.day === selectedDay
      );

      const weekOffText = allWeeksSelected
        ? "All Week Off"
        : Object.keys(weeks)
          .filter((week) => weeks[week]) // Only selected weeks (true)
          .map((week, index) => {
            const weekIndex = index + 1;
            const weekSuffix =
              weekIndex === 1
                ? "st"
                : weekIndex === 2
                  ? "nd"
                  : weekIndex === 3
                    ? "rd"
                    : "th";
            return `${weekIndex}${weekSuffix}`;
          })
          .join(", ") + " Week is Off";

      if (index !== -1) {
        // If found, update the entry at that index
        return prevDayWiseWeekOff.map((day, idx) =>
          idx === index
            ? { ...day, weekOff: weeks, weekOffText } // Add the text for "All Week Off" or selected weeks
            : day
        );
      } else {
        // If the day isn't found, add a new entry at the end
        return [
          ...prevDayWiseWeekOff,
          { day: selectedDay, weekOff: weeks, weekOffText },
        ];
      }
    });

    // Reset the weeks state to false (indicating no weeks are selected)
    setWeeks({
      firstWeek: false,
      secondWeek: false,
      thirdWeek: false,
      fourthWeek: false,
      fifthWeek: false,
    });

    // Reset the allWeeksSelected state to false (if it's being tracked)
    setAllWeeksSelected(false);

    // Close the modal after confirming
    closeModal22();
  };

  const [weekoff, setWeekOff] = useState({
    Mon: false,
    Tue: false,
    Wed: false,
    Thu: false,
    Fri: false,
    Sat: false,
    Sun: false,
  });

  const [Shift, setShift] = useState({
    shiftOne: [],
    shiftTwo: [],
    shiftThree: [],
    shiftFour: [],
    shiftFive: [],
    shiftSix: [],
    shiftSeven: [],
  });

  function getMatchingShiftIds(selectedShift, selectMonShift) {
    // Ensure selectMonShift is an array, or default to an empty array
    const selectMonShiftArray = Array.isArray(selectMonShift)
      ? selectMonShift
      : [];

    // Map to extract labels from selectMonShift
    const selectMonShiftlabel = selectMonShiftArray?.map(
      (shift) => shift?.label
    );

    const matchingShiftIds = selectedShift
      ?.filter((shift) => {
        const label = `${shift?.shiftName} | ${shift?.shiftStartTime} - ${shift?.shiftEndTime}`;
        return selectMonShiftlabel?.includes(label); // Check if label exists in selectMonShiftlabel
      })
      ?.map((shift) => shift?.id); // Extract only the id

    return matchingShiftIds;
  }
  const [weekName, setWeekName] = useState("");

  const [dayWiseWeekOff, setDayWiseWeekOff] = useState([
    {
      day: "Mon",
      weekOff: {
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      },
    },
    {
      day: "Tue",
      weekOff: {
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      },
    },
    {
      day: "Wed",
      weekOff: {
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      },
    },
    {
      day: "Thu",
      weekOff: {
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      },
    },
    {
      day: "Fri",
      weekOff: {
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      },
    },
    {
      day: "Sat",
      weekOff: {
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      },
    },
    {
      day: "Sun",
      weekOff: {
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      },
    },
  ]);

  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const getDayName = (date) => {
    return date.toLocaleDateString("en-US", { weekday: "short" });
  };

  const [dateTime, setDateTime] = useState([]);
  const [flexibleDay, setFlexibleDay] = useState([]);

  useEffect(() => {
    if (selectedMonth) {
      const year = selectedMonth.getFullYear();
      const month = selectedMonth.getMonth();

      const lastDayOfMonth = new Date(year, month + 1, 0); // Last day of the current month
      const days = Array.from(
        { length: lastDayOfMonth.getDate() },
        (_, i) => i + 1
      );

      setDateTime(days);
    }
  }, [selectedMonth]);

  console.log(dateTime);
  async function createFlexibleShift(e) {
    const data = {
      // staffId: selectedId,
      // shifts: flexibleDay?.map(( , shifts, weekOff) => ({
      //     dateTime: dateTime,
      //     weekOff: weekOff,
      //     shifts: getMatchingShiftIds(selectedShift, shifts),
      // }))
      staffId: selectedId,
      shifts: flexibleDay?.map((flexibleShift) => ({
        dateTime: flexibleShift.day, // Access the `day` property for `dateTime`
        weekOff: flexibleShift.weekOff, // Access the `weekOff` property directly
        shifts: getMatchingShiftIds(selectedShift, flexibleShift.shifts), // Use `flexibleShift.shifts` for matching
      })),
    };
    setIsFlexibleShiftCreating(true);
    try {
      const response = await fetch(`${baseUrl}shift/flexible-shift/update`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (response.status === 200) {
        setIsFlexibleShiftCreating(false);
        openToast("Flexible Shift Updated or Added Successfully", "success");

        setFlexibleDay([]);
        setSelectedId([]);
        setSelectedWeeks({
          Mon: [],
          Tue: [],
          Wed: [],
          Thu: [],
          Fri: [],
          Sat: [],
          Sun: [],
        });

        closeModal();
      } else {
        openToast(
          "An error occurred while adding or updating Flexible Shift Work Timing",
          "error"
        );
      }
      closeModal();
    } catch (error) {
      openToast(
        "An error occurred while adding or updating Flexible Shift Work Timing",
        "error"
      );
    } finally {
      setIsFlexibleShiftCreating(false);
    }
  }

  const [fixedShiftSubmission, setFixedShiftSubmission] = useState(false);
  async function submitFixedShifts() {
    if(selectedId?.length==0){
      openToast("Please Select Staff", "warning");
      return 
    }

    const data = {
      staffId: selectedId,
      shifts: [
        {
          day: "Mon",
          weekOff: weekoff.Mon,
          shifts: getMatchingShiftIds(selectedShift, Shift.shiftOne),
          ...(weekoff.Mon && {
            weekOne: dayWiseWeekOff?.find((day) => day.day === "Mon")?.weekOff
              ?.firstWeek,
            weekTwo: dayWiseWeekOff?.find((day) => day.day === "Mon")?.weekOff
              ?.secondWeek,
            weekThree: dayWiseWeekOff?.find((day) => day.day === "Mon")?.weekOff
              ?.thirdWeek,
            weekFour: dayWiseWeekOff?.find((day) => day.day === "Mon")?.weekOff
              ?.fourthWeek,
            weekFive: dayWiseWeekOff?.find((day) => day.day === "Mon")?.weekOff
              ?.fifthWeek,
          }),
        },
        {
          day: "Tue",
          weekOff: weekoff.Tue,
          shifts: getMatchingShiftIds(selectedShift, Shift.shiftTwo),
          ...(weekoff.Tue && {
            weekOne: dayWiseWeekOff?.find((day) => day.day === "Tue")?.weekOff
              ?.firstWeek,
            weekTwo: dayWiseWeekOff?.find((day) => day.day === "Tue")?.weekOff
              ?.secondWeek,
            weekThree: dayWiseWeekOff?.find((day) => day.day === "Tue")?.weekOff
              ?.thirdWeek,
            weekFour: dayWiseWeekOff?.find((day) => day.day === "Tue")?.weekOff
              ?.fourthWeek,
            weekFive: dayWiseWeekOff?.find((day) => day.day === "Tue")?.weekOff
              ?.fifthWeek,
          }),
        },
        {
          day: "Wed",
          weekOff: weekoff.Wed,
          shifts: getMatchingShiftIds(selectedShift, Shift.shiftThree),
          ...(weekoff.Wed && {
            weekOne: dayWiseWeekOff?.find((day) => day.day === "Wed")?.weekOff
              ?.firstWeek,
            weekTwo: dayWiseWeekOff?.find((day) => day.day === "Wed")?.weekOff
              ?.secondWeek,
            weekThree: dayWiseWeekOff?.find((day) => day.day === "Wed")?.weekOff
              ?.thirdWeek,
            weekFour: dayWiseWeekOff?.find((day) => day.day === "Wed")?.weekOff
              ?.fourthWeek,
            weekFive: dayWiseWeekOff?.find((day) => day.day === "Wed")?.weekOff
              ?.fifthWeek,
          }),
        },
        {
          day: "Thu",
          weekOff: weekoff.Thu,
          shifts: getMatchingShiftIds(selectedShift, Shift.shiftFour),
          ...(weekoff.Thu && {
            weekOne: dayWiseWeekOff?.find((day) => day.day === "Thu")?.weekOff
              ?.firstWeek,
            weekTwo: dayWiseWeekOff?.find((day) => day.day === "Thu")?.weekOff
              ?.secondWeek,
            weekThree: dayWiseWeekOff?.find((day) => day.day === "Thu")?.weekOff
              ?.thirdWeek,
            weekFour: dayWiseWeekOff?.find((day) => day.day === "Thu")?.weekOff
              ?.fourthWeek,
            weekFive: dayWiseWeekOff?.find((day) => day.day === "Thu")?.weekOff
              ?.fifthWeek,
          }),
        },
        {
          day: "Fri",
          weekOff: weekoff.Fri,
          shifts: getMatchingShiftIds(selectedShift, Shift.shiftFive),
          ...(weekoff.Fri && {
            weekOne: dayWiseWeekOff?.find((day) => day.day === "Fri")?.weekOff
              ?.firstWeek,
            weekTwo: dayWiseWeekOff?.find((day) => day.day === "Fri")?.weekOff
              ?.secondWeek,
            weekThree: dayWiseWeekOff?.find((day) => day.day === "Fri")?.weekOff
              ?.thirdWeek,
            weekFour: dayWiseWeekOff?.find((day) => day.day === "Fri")?.weekOff
              ?.fourthWeek,
            weekFive: dayWiseWeekOff?.find((day) => day.day === "Fri")?.weekOff
              ?.fifthWeek,
          }),
        },
        {
          day: "Sat",
          weekOff: weekoff.Sat,
          shifts: getMatchingShiftIds(selectedShift, Shift.shiftSix),
          ...(weekoff.Sat && {
            weekOne: dayWiseWeekOff?.find((day) => day.day === "Sat")?.weekOff
              ?.firstWeek,
            weekTwo: dayWiseWeekOff?.find((day) => day.day === "Sat")?.weekOff
              ?.secondWeek,
            weekThree: dayWiseWeekOff?.find((day) => day.day === "Sat")?.weekOff
              ?.thirdWeek,
            weekFour: dayWiseWeekOff?.find((day) => day.day === "Sat")?.weekOff
              ?.fourthWeek,
            weekFive: dayWiseWeekOff?.find((day) => day.day === "Sat")?.weekOff
              ?.fifthWeek,
          }),
        },
        {
          day: "Sun",
          weekOff: weekoff.Sun,
          shifts: getMatchingShiftIds(selectedShift, Shift.shiftSeven),
          ...(weekoff.Sun && {
            weekOne: dayWiseWeekOff?.find((day) => day.day === "Sun")?.weekOff
              ?.firstWeek,
            weekTwo: dayWiseWeekOff?.find((day) => day.day === "Sun")?.weekOff
              ?.secondWeek,
            weekThree: dayWiseWeekOff?.find((day) => day.day === "Sun")?.weekOff
              ?.thirdWeek,
            weekFour: dayWiseWeekOff?.find((day) => day.day === "Sun")?.weekOff
              ?.fourthWeek,
            weekFive: dayWiseWeekOff?.find((day) => day.day === "Sun")?.weekOff
              ?.fifthWeek,
          }),
        },
      ],
    };

    setFixedShiftSubmission(true);
    try {
      const response = await fetch(`${baseUrl}shift/fixed-shift/update`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (response.status === 200) {
        openToast("Fixed Shift Updated or Added Successfully", "success");
        setFixedShiftSubmission(false);
        setSelectedId([]);
        setShift({
          shiftOne: [],
          shiftTwo: [],
          shiftThree: [],
          shiftFour: [],
          shiftFive: [],
          shiftSix: [],
          shiftSeven: [],
        });
        setWeeks({
          firstWeek: false,
          secondWeek: false,
          thirdWeek: false,
          fourthWeek: false,
          fifthWeek: false,
        });
        setSelectedId([]);
        setSelectedWeeks({
          Mon: [],
          Tue: [],
          Wed: [],
          Thu: [],
          Fri: [],
          Sat: [],
          Sun: [],
        });

        setAllWeeksSelected(false);
        setWeekOff({
          Mon: false,
          Tue: false,
          Wed: false,
          Thu: false,
          Fri: false,
          Sat: false,
          Sun: false,
        });
      } else {
        openToast(
          "An error occurred while adding or updating Work Timing",
          "error"
        );
      }
      closeModal();
    } catch (error) {
      openToast(
        "An error occurred while adding or updating Work Timing",
        "error"
      );
    } finally {
      setFixedShiftSubmission(false);
      setSelectedId([]);
      setShift({
        shiftOne: [],
        shiftTwo: [],
        shiftThree: [],
        shiftFour: [],
        shiftFive: [],
        shiftSix: [],
        shiftSeven: [],
      });
      setWeeks({
        firstWeek: false,
        secondWeek: false,
        thirdWeek: false,
        fourthWeek: false,
        fifthWeek: false,
      });
      setSelectedId([]);
      setSelectedWeeks({
        Mon: [],
        Tue: [],
        Wed: [],
        Thu: [],
        Fri: [],
        Sat: [],
        Sun: [],
      });

      setAllWeeksSelected(false);
      setWeekOff({
        Mon: false,
        Tue: false,
        Wed: false,
        Thu: false,
        Fri: false,
        Sat: false,
        Sun: false,
      });
    }
  }

  console.log(Shift);

  const handleSelectAll = () => {
    const newSelectAll = !selectAll; // Determine the new value of selectAll
    setSelectAll(newSelectAll);

    if (newSelectAll) {
      // If selectAll is true, select all staff IDs
      const allStaffIds = staffs?.map((staff) => staff?.staffDetails?.id);
      setSelectedId(allStaffIds);
    } else {
      // If selectAll is false, clear the selection
      setSelectedId([]);
    }
  };

  if (loadingStaffs && !staffs) {
    return (
      <div className="mt-[20px] staff-tab">
        <HeaderSkeleton />
        <TableSkeleton />
        <PaginationSkeleton />
      </div>
    );
  }

  return (
    <div className="mt-[20px] attendance-tab">
      <div className="tabs-attendance">
        <Tabs>
          <TabList className="flex lg:flex-row xl:flex-row flex-col gap-[10px] mb-[20px]">
            <Tab>
              <button>Work Timings</button>
            </Tab>
            <Tab>
              {" "}
              <button>Attendance Modes</button>
            </Tab>
            <Tab>
              {" "}
              <button>Automation Rules</button>
            </Tab>
          </TabList>

          <TabPanel>
            <div className="flex xl:flex-row flex-col md:flex-col lg:flex-col justify-between gap-[15px] lg:gap-[15px]">
              <SearchStaff
                dropdownRef={dropdownRef}
                isDropdownOpen={isDropdownOpen}
                setDropdownOpen={setDropdownOpen}
                toggleDropdown={toggleDropdown}
              />
              <div className="flex justify-between lg:justify-start gap-[15px]">
                <div>
                  <div className="inline-block relative text-left">
                    <div>
                      <button
                        type="button"
                        onClick={openModal}
                        className="shadow-sm w-full text-white second-btn"
                        id="menu-button"
                        aria-expanded="true"
                        aria-haspopup="true"
                      >
                        Update Work Timings
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex shadow mt-4 p-0 border border-1 rounded-md w-[100%] h-[100%] overflow-scroll overflow-y-auto">
              <div className="w-full">
                <table className="table-section w-full">
                  <thead className="top-[-1px] sticky bg-[#fff] set-shadow border border-1">
                    <th>
                      <input
                        type="checkbox"
                        className="border border-1 rounded-md"
                        checked={selectAll}
                        onClick={() => handleSelectAll()}
                      />
                    </th>
                    <th>Name</th>
                    <th>Job Title</th>
                    <th>Schedule Type</th>
                  </thead>
                  <tbody>
                    {loadingStaffs && !staffs && (
                      <tr className="h-[100px]">
                        <td
                          colSpan="11"
                          className="py-4 font-semibold text-gray-600 text-xl text-center"
                        >
                          <ClipLoader color="#27004a" size={50} />
                        </td>
                      </tr>
                    )}

                    {!loadingStaffs &&
                      staffs &&
                      staffs?.map((item) => {
                        return (
                          <tr className="border">
                            <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                              <input
                                checked={selectedId.includes(
                                  item?.staffDetails?.id
                                )}
                                onChange={(e) =>
                                  setSelectedId((prevSelectedId) => {
                                    if (
                                      prevSelectedId.includes(
                                        item?.staffDetails?.id
                                      )
                                    ) {
                                      // Remove the ID if it is already present
                                      return prevSelectedId.filter(
                                        (id) => id !== item?.staffDetails?.id
                                      );
                                    } else {
                                      // Add the ID if it is not present
                                      return [
                                        ...prevSelectedId,
                                        item?.staffDetails?.id,
                                      ];
                                    }
                                  })
                                }
                                type="checkbox"
                                className="border border-1 rounded-md"
                              />
                            </td>
                            <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                              <Link
                                to={`/staff-salary-summary`}
                                onClick={() => setSelectedStaff(item)}
                                className="font-medium text-[#8A25B0]"
                              >
                                {item?.name}
                              </Link>
                            </td>
                            <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                              {item?.staffDetails?.job_title}
                            </td>
                            <td>{item?.staffDetails?.FixedShift?.length > 0 && "Fixed"} {item?.staffDetails?.FixedShift?.length === 0 && item?.staffDetails?.FlexibleShift?.length === 0 && "N/A"}
                              {item?.staffDetails?.FlexibleShift?.length > 0 && "Flexible"}</td>
                          </tr>
                        );
                      })}
                    {!loadingStaffs && staffs && staffs?.length === 0 && (
                      <tr>
                        <td
                          colSpan="11"
                          className="py-4 font-semibold text-gray-600 text-xl text-center"
                        >
                          No Client Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <PaginationTab />
          </TabPanel>
          <TabPanel>
            <div className="flex xl:flex-row flex-col md:flex-col lg:flex-col justify-between gap-[15px] lg:gap-[15px]">
              <div className="flex justify-between lg:justify-start gap-[15px] w-full">
                <>
                  <SearchStaff
                    dropdownRef={dropdownRef}
                    isDropdownOpen={isDropdownOpen}
                    setDropdownOpen={setDropdownOpen}
                    toggleDropdown={toggleDropdown}
                  />
                  <div className="inline-block relative text-left">
                    <div>
                      <button
                        type="button"
                        // disabled={selectedId.length === 0}
                        onClick={handleUpdate}
                        className="shadow-sm w-full text-white second-btn"
                        id="menu-button"
                        aria-expanded="true"
                        aria-haspopup="true"
                      >
                        Update Attendance Modes
                      </button>
                    </div>
                  </div>
                </>
              </div>
            </div>

            <div className="flex shadow mt-4 p-0 border border-1 rounded-md w-[100%] h-[100%] overflow-scroll overflow-y-auto">
              <div className="w-full">
                <table className="table-section w-full">
                  <thead className="border border-1">
                    <th>
                      <input
                        type="checkbox"
                        checked={selectAll}
                        className="border border-1 rounded-md"
                        onClick={() => handleSelectAll()}
                      />
                    </th>
                    <th>Name</th>
                    <th>Job Title</th>
                    <th>GPS Attendance</th>
                    <th>Selfie</th>
                    <th>QR</th>
                    <th>Mark Attendance From</th>
                    {/* <th>Biometric</th> */}
                  </thead>
                  <tbody className="">
                    {isLoading ? (
                      <tr className="h-[100px]">
                        <td
                          colSpan="9"
                          className="py-4 font-semibold text-gray-600 text-xl text-center"
                        >
                          <ClipLoader color="#4A90E2" size={50} />
                        </td>
                      </tr>
                    ) : staffs && staffs?.length > 0 ? (
                      staffs?.map((item, index) => {
                        return (
                          <>
                            {" "}
                            <tr className="border">
                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                <input
                                  checked={selectedId.includes(
                                    item?.staffDetails?.id
                                  )}
                                  onChange={(e) =>
                                    setSelectedId((prevSelectedId) => {
                                      if (
                                        prevSelectedId?.includes(
                                          item?.staffDetails?.id
                                        )
                                      ) {
                                        return prevSelectedId?.filter(
                                          (id) => id !== item?.staffDetails?.id
                                        );
                                      } else {
                                        return [
                                          ...prevSelectedId,
                                          item?.staffDetails?.id,
                                        ];
                                      }
                                    })
                                  }
                                  type="checkbox"
                                  className="border border-1 rounded-md"
                                />
                              </td>
                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                <Link
                                  to={`/personal-detail/${item?.staffDetails?.id}`}
                                  onClick={() => setSelectedStaff(item)}
                                  className="font-medium text-[#8A25B0]"
                                >
                                  {item?.name}
                                </Link>{" "}
                              </td>
                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                {item?.staffDetails?.job_title}
                              </td>

                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                {item?.staffDetails?.AttendenceMode?.gps_attendance == true ? "Active"
                                  : "InActive"}
                              </td>
                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                {item?.staffDetails?.AttendenceMode?.selfie_attendance == true ? "Active"
                                  : "InActive"}
                              </td>
                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                {item?.staffDetails?.AttendenceMode?.qr_attendance == true ? "Active"
                                  : "InActive"}
                              </td>
                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                {
                                  item?.staffDetails?.AttendenceMode
                                    ?.mark_attendance || "N/A"
                                }
                              </td>
                            </tr>
                          </>
                        );
                      })
                    ) : (
                      // No Data State
                      <tr className="h-[100px]">
                        <td
                          colSpan="9"
                          className="py-4 font-semibold text-red-500 text-xl text-center"
                        >
                          No staff found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <PaginationTab />
          </TabPanel>

          <TabPanel>
            <div className="flex xl:flex-row flex-col md:flex-col lg:flex-col justify-between gap-[15px] lg:gap-[15px]">
              <SearchStaff
                dropdownRef={dropdownRef}
                isDropdownOpen={isDropdownOpen}
                setDropdownOpen={setDropdownOpen}
                toggleDropdown={toggleDropdown}
              />
              <div className="flex justify-between lg:justify-start gap-[15px]">
                <div>
                  <div className="inline-block relative text-left">
                    <div>
                      <button
                        type="button"
                        // disabled={selectedId.length === 0}
                        onClick={handleUpdateAutoMation}
                        className="shadow-sm w-full text-white second-btn"
                        id="menu-button"
                        aria-expanded="true"
                        aria-haspopup="true"
                      >
                        Update Automation Rules
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex shadow mt-4 p-0 border border-1 rounded-md w-[100%] h-[100%] overflow-scroll overflow-y-auto">
              <div className="w-full">
                <table className="table-section w-full">
                  <thead className="border border-1">
                    <th>
                      <input
                        type="checkbox"
                        checked={selectAll}
                        className="border border-1 rounded-md"
                        onClick={() => handleSelectAll()}
                      />
                    </th>
                    <th>Name</th>
                    <th>Job Title</th>
                    <th>Auto Present</th>
                    <th>Present On Punch In</th>
                    <th>Auto Half Day</th>
                    <th>Mandatory Half Day Hours</th>
                    <th>Mandatory Full Day Hours</th>
                  </thead>
                  <tbody className="">
                    {isLoading ? (
                      <tr className="h-[100px]">
                        <td
                          colSpan="9"
                          className="py-4 font-semibold text-gray-600 text-xl text-center"
                        >
                          <ClipLoader color="#4A90E2" size={50} />
                        </td>
                      </tr>
                    ) : staffs && staffs?.length > 0 ? (
                      staffs?.map((item, index) => {
                        return (
                          <>
                            {" "}
                            <tr className="border">
                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                <input
                                  checked={selectedId.includes(
                                    item?.staffDetails?.id
                                  )}
                                  onChange={(e) =>
                                    setSelectedId((prevSelectedId) => {
                                      if (
                                        prevSelectedId?.includes(
                                          item?.staffDetails?.id
                                        )
                                      ) {
                                        return prevSelectedId?.filter(
                                          (id) => id !== item?.staffDetails?.id
                                        );
                                      } else {
                                        return [
                                          ...prevSelectedId,
                                          item?.staffDetails?.id,
                                        ];
                                      }
                                    })
                                  }
                                  type="checkbox"
                                  className="border border-1 rounded-md"
                                />
                              </td>
                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                <Link
                                  to={`/personal-detail/${item?.staffDetails?.id}`}
                                  onClick={() => setSelectedStaff(item)}
                                  className="font-medium text-[#8A25B0]"
                                >
                                  {item?.name}
                                </Link>
                              </td>
                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                {item?.staffDetails?.job_title}
                              </td>
                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                {item?.staffDetails?.attendanceAutomationRule
                                  ?.auto_absent
                                  ? "Active"
                                  : "InActive"}
                              </td>
                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                {item?.staffDetails?.attendanceAutomationRule
                                  ?.present_on_punch
                                  ? "Active"
                                  : "InActive"}
                              </td>
                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                {item?.staffDetails?.attendanceAutomationRule?.auto_half_day?.includes("undefined")
                                  ? "N/A"
                                  : item?.staffDetails?.attendanceAutomationRule?.auto_half_day}

                              </td>
                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                {item?.staffDetails?.attendanceAutomationRule?.manadatory_half_day?.includes("undefined")
                                  ? "N/A"
                                  : item?.staffDetails?.attendanceAutomationRule?.manadatory_half_day}
                              </td>
                              <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                                {item?.staffDetails?.attendanceAutomationRule?.manadatory_full_day?.includes("undefined")
                                  ? "N/A"
                                  : item?.staffDetails?.attendanceAutomationRule?.manadatory_full_day}
                              </td>
                            </tr>
                          </>
                        );
                      })
                    ) : (
                      // No Data State
                      <tr className="h-[100px]">
                        <td
                          colSpan="9"
                          className="py-4 font-semibold text-red-500 text-xl text-center"
                        >
                          No staff found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <PaginationTab />
          </TabPanel>
        </Tabs>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="p-3 border-[#000] border-b text-[14px]"
        >
          Bulk Update Work Timings for All Staff
        </h2>
        <button
          onClick={closeModal}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <Tabs className="fixed-tab-section p-[s0px]">
          <TabList className="flex justify-around items-center bg-[#F4F5F9] m-2 xl:m-2 mt-3 mb-2 pt-[10px] pb-[10px] rounded-md">
            <label className="text-[14px]">Select Type</label>
            <Tab
              onClick={() => setSelectShiftType("Fixed")}
              className="flex items-center gap-[10px] cursor-pointer"
            >
              <input
                onClick={() => setSelectShiftType("Fixed")}
                checked={selectShiftType === "Fixed"}
                type="radio"
                id="fixed"
                name="fixed"
                className="rounded-full"
              />
              <label for="fixed" className="text-[14px]">
                {" "}
                Fixed
              </label>
              <br />
            </Tab>
            <Tab
              onClick={() => setSelectShiftType("Flexible")}
              className="flex items-center gap-[10px] cursor-pointer"
            >
              <input
                onClick={() => setSelectShiftType("Flexible")}
                checked={selectShiftType === "Flexible"}
                type="radio"
                id="flexible"
                name="fixed"
                className="rounded-full"
              />
              <label for="flexible" className="text-[14px]">
                {" "}
                Flexible
              </label>
              <br />
            </Tab>
          </TabList>

          <TabPanel>
            <div className="first-panel">
              <div className="flex justify-center items-center gap-4">
                <h2 className="text-[14px]">Select All</h2>
                <div className="pr-5">
                  <Select
                    // isDisabled={updateWeekOff.weekOff}
                    options={options}
                    isMulti
                    placeholder="Select Shift"
                    value={Shift.shiftOne}
                    onChange={(selected) => {
                      console.log(selected);
                      setShift({
                        shiftOne: selected,
                        shiftTwo: selected,
                        shiftThree: selected,
                        shiftFour: selected,
                        shiftFive: selected,
                        shiftSix: selected,
                        shiftSeven: selected,
                      });
                    }}
                    onMenuOpen={() =>
                      selectedShift?.length === 0 && openModal1()
                    }
                    className="bg-[#fff] p-[6px] rounded-md focus-visible:outline-none w-[100%] lg:w-[240px] text-sm"
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: "40px",
                        // maxHeight: '30px',
                        // overflow: "scroll",
                        // scrollBehavior: "smooth",
                        // scrollbarWidth: "none",
                        // overflowX: "hidden",
                      }),
                      multiValue: (base) => ({
                        ...base,
                        backgroundColor: "#e5e7eb",
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        color: "#000",
                        // height: '30px',
                        // display:"flex",
                        // flexDirection:"column",
                        // justifyContent:"center",
                        // alignItems: 'center',
                      }),
                      multiValueRemove: (base) => ({
                        ...base,
                        color: "#ff0000",
                        cursor: "pointer",
                      }),
                    }}
                  />
                </div>
              </div>
              <div className="h-[50vh] overflow-y-scroll">
                <table className="w-full">
                  <thead className="border-[#000] border-b">
                    <th className="p-3 font-medium text-[13px]">Day </th>
                    <th className="p-3 w-[45px] font-medium text-[13px]">
                      Weekoff{" "}
                    </th>
                    <th className="p-3 pl-[8px] font-medium text-[13px] text-center">
                      Shifts
                    </th>
                  </thead>
                  <tbody>
                    <tr className="">
                      <td className="font-normal text-[12px] text-center">
                        Mon
                      </td>
                      <td className="p-3 text-center">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setWeekName("Monday");
                            setWeekOff({ ...weekoff, Mon: !weekoff.Mon });
                            // setIsOpen22(!modalIsOpen22);
                          }}
                          checked={weekoff.Mon}
                        />
                      </td>
                      <div className="flex flex-col p-[5px]">
                        {weekoff.Mon ? (
                          <td className="w-[100%]">
                            <select
                              onClick={openModal22}
                              className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                            >
                              <option selected>
                                {selectedWeeks?.["Mon"]
                                  ? selectedWeeks["Mon"]
                                  : "No Week Off for Monday"}
                              </option>
                            </select>
                          </td>
                        ) : (
                          <td className="flex items-center pr-5">
                            <Select
                              options={options}
                              isMulti
                              placeholder="Select Shift"
                              value={Shift.shiftOne}
                              onChange={(selected) =>
                                setShift({ ...Shift, shiftOne: selected })
                              }
                              onMenuOpen={() =>
                                selectedShift?.length === 0 && openModal1()
                              }
                              className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[94%] text-[#000] text-[12px] xl:text-[14px]"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: "40px",
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: "#e5e7eb",
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: "#000",
                                }),
                                multiValueRemove: (base) => ({
                                  ...base,
                                  color: "#ff0000",
                                  cursor: "pointer",
                                }),
                              }}
                            />
                            <button className="bg-[#27004a] ml-4 rounded-full">
                              <AddIcon
                                className="text-white"
                                onClick={openModal1}
                              />
                            </button>
                          </td>
                        )}
                      </div>
                    </tr>
                    <tr className="">
                      <td className="font-normal text-[12px] text-center">
                        Tue
                      </td>
                      <td className="p-3 text-center">
                        <input
                          type="checkbox"
                          onChange={() => {
                            // setWeekOff(() => ({ ...weekoff, Tue: !weekoff.Tue }));
                            setWeekName("Tuesday");
                            setWeekOff({ ...weekoff, Tue: !weekoff.Tue });
                            // setIsOpen22(!modalIsOpen22);
                          }}
                          checked={weekoff.Tue}
                        />
                      </td>
                      <div className="flex flex-col p-[5px]">
                        {weekoff.Tue ? (
                          <td className="w-[100%]">
                            <select
                              onClick={openModal22}
                              className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                            >
                              <option>
                                {selectedWeeks?.["Tue"]
                                  ? selectedWeeks["Tue"]
                                  : "No Week Off for Tuesday"}
                              </option>
                            </select>
                          </td>
                        ) : (
                          <td className="flex items-center pr-5">
                            <Select
                              options={options}
                              isMulti
                              placeholder="Select Shift"
                              value={Shift.shiftTwo}
                              onChange={(selected) =>
                                setShift({ ...Shift, shiftTwo: selected })
                              }
                              onMenuOpen={() =>
                                selectedShift?.length === 0 && openModal1()
                              }
                              className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[94%] text-[#000] text-[12px] xl:text-[14px]"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: "40px",
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: "#e5e7eb",
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: "#000",
                                }),
                                multiValueRemove: (base) => ({
                                  ...base,
                                  color: "#ff0000",
                                  cursor: "pointer",
                                }),
                              }}
                            />
                            <button className="bg-[#27004a] ml-4 rounded-full">
                              <AddIcon
                                className="text-white"
                                onClick={openModal1}
                              />
                            </button>
                          </td>
                        )}
                      </div>
                    </tr>
                    <tr className="">
                      <td className="font-normal text-[12px] text-center">
                        Wed
                      </td>
                      <td className="p-3 text-center">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setWeekName("Wednesday");
                            setWeekOff({ ...weekoff, Wed: !weekoff.Wed });
                            // setIsOpen22(!modalIsOpen22);
                          }}
                          checked={weekoff.Wed}
                        />
                      </td>
                      <div className="flex flex-col p-[5px]">
                        {weekoff.Wed ? (
                          <td className="w-[100%]">
                            <select
                              onClick={openModal22}
                              className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                            >
                              <option>
                                {selectedWeeks?.["Wed"]
                                  ? selectedWeeks["Wed"]
                                  : "No Week Off for Wednesday"}
                              </option>
                            </select>
                          </td>
                        ) : (
                          <td className="flex items-center pr-5">
                            <Select
                              options={options}
                              isMulti
                              placeholder="Select Shift"
                              value={Shift.shiftThree}
                              onChange={(selected) =>
                                setShift({ ...Shift, shiftThree: selected })
                              }
                              onMenuOpen={() =>
                                selectedShift?.length === 0 && openModal1()
                              }
                              className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[94%] text-[#000] text-[12px] xl:text-[14px]"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: "40px",
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: "#e5e7eb",
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: "#000",
                                }),
                                multiValueRemove: (base) => ({
                                  ...base,
                                  color: "#ff0000",
                                  cursor: "pointer",
                                }),
                              }}
                            />
                            <button className="bg-[#27004a] ml-4 rounded-full">
                              <AddIcon
                                className="text-white"
                                onClick={openModal1}
                              />
                            </button>
                          </td>
                        )}
                      </div>
                    </tr>
                    <tr className="">
                      <td className="font-normal text-[12px] text-center">
                        Thu
                      </td>
                      <td className="p-3 text-center">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setWeekName("Thursday");
                            setWeekOff({ ...weekoff, Thu: !weekoff.Thu });
                            // setIsOpen22(!modalIsOpen22);
                          }}
                          checked={weekoff.Thu}
                          className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                        />
                      </td>
                      <div className="flex flex-col p-[5px]">
                        {weekoff.Thu ? (
                          <td className="w-[100%]">
                            <select
                              onClick={openModal22}
                              className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                            >
                              <option>
                                {selectedWeeks?.["Thu"]
                                  ? selectedWeeks["Thu"]
                                  : "No Week Off for Thursday"}
                              </option>
                            </select>
                          </td>
                        ) : (
                          <td className="flex items-center pr-5">
                            <Select
                              options={options}
                              isMulti
                              placeholder="Select Shift"
                              value={Shift.shiftFour}
                              onChange={(selected) =>
                                setShift({ ...Shift, shiftFour: selected })
                              }
                              onMenuOpen={() =>
                                selectedShift?.length === 0 && openModal1()
                              }
                              className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[94%] text-[#000] text-[12px] xl:text-[14px]"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: "40px",
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: "#e5e7eb",
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: "#000",
                                }),
                                multiValueRemove: (base) => ({
                                  ...base,
                                  color: "#ff0000",
                                  cursor: "pointer",
                                }),
                              }}
                            />
                            <button className="bg-[#27004a] ml-4 rounded-full">
                              <AddIcon
                                className="text-white"
                                onClick={openModal1}
                              />
                            </button>
                          </td>
                        )}
                      </div>
                    </tr>
                    <tr className="">
                      <td className="font-normal text-[12px] text-center">
                        Fri
                      </td>
                      <td className="p-3 text-center">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setWeekName("Friday");
                            setWeekOff({ ...weekoff, Fri: !weekoff.Fri });
                            // setIsOpen22(!modalIsOpen22);
                          }}
                          checked={weekoff.Fri}
                        />
                      </td>
                      <div className="flex flex-col p-[5px]">
                        {weekoff.Fri ? (
                          <td className="w-[100%]">
                            <select
                              onClick={openModal22}
                              className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                            >
                              <option>
                                {selectedWeeks?.["Fri"]
                                  ? selectedWeeks["Fri"]
                                  : "No Week Off for Fri"}
                              </option>
                            </select>
                          </td>
                        ) : (
                          <td className="flex items-center pr-5">
                            <Select
                              options={options}
                              isMulti
                              placeholder="Select Shift"
                              value={Shift.shiftFive}
                              onChange={(selected) =>
                                setShift({ ...Shift, shiftFive: selected })
                              }
                              onMenuOpen={() =>
                                selectedShift?.length === 0 && openModal1()
                              }
                              className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[94%] text-[#000] text-[12px] xl:text-[14px]"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: "40px",
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: "#e5e7eb",
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: "#000",
                                }),
                                multiValueRemove: (base) => ({
                                  ...base,
                                  color: "#ff0000",
                                  cursor: "pointer",
                                }),
                              }}
                            />
                            <button className="bg-[#27004a] ml-4 rounded-full">
                              <AddIcon
                                className="text-white"
                                onClick={openModal1}
                              />
                            </button>
                          </td>
                        )}
                      </div>
                    </tr>
                    <tr className="">
                      <td className="font-normal text-[12px] text-center">
                        Sat
                      </td>
                      <td className="p-3 text-center">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setWeekName("Saturday");
                            setWeekOff({ ...weekoff, Sat: !weekoff.Sat });
                            // setIsOpen22(!modalIsOpen22);
                          }}
                          checked={weekoff.Sat}
                        />
                      </td>
                      <div className="flex flex-col p-[5px]">
                        {weekoff.Sat ? (
                          <td className="w-[100%]">
                            <select
                              onClick={openModal22}
                              className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                            >
                              <option>
                                {selectedWeeks?.["Sat"]
                                  ? selectedWeeks["Sat"]
                                  : "No Week Off for Monday"}
                              </option>
                            </select>
                          </td>
                        ) : (
                          <td className="flex items-center pr-5">
                            <Select
                              options={options}
                              isMulti
                              placeholder="Select Shift"
                              value={Shift.shiftSix}
                              onChange={(selected) =>
                                setShift({ ...Shift, shiftSix: selected })
                              }
                              onMenuOpen={() =>
                                selectedShift?.length === 0 && openModal1()
                              }
                              className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[94%] text-[#000] text-[12px] xl:text-[14px]"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: "40px",
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: "#e5e7eb",
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: "#000",
                                }),
                                multiValueRemove: (base) => ({
                                  ...base,
                                  color: "#ff0000",
                                  cursor: "pointer",
                                }),
                              }}
                            />
                            <button className="bg-[#27004a] ml-4 rounded-full">
                              <AddIcon
                                className="text-white"
                                onClick={openModal1}
                              />
                            </button>
                          </td>
                        )}
                      </div>
                    </tr>
                    <tr className="">
                      <td className="font-normal text-[12px] text-center">
                        Sun
                      </td>
                      <td className="p-3 text-center">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setWeekName("Sunday");
                            setWeekOff({ ...weekoff, Sun: !weekoff.Sun });
                            // setIsOpen22(!modalIsOpen22);
                          }}
                          checked={weekoff.Sun}
                        />
                      </td>
                      <div className="flex flex-col p-[5px]">
                        {weekoff.Sun ? (
                          <td className="w-[100%]">
                            <select
                              onClick={openModal22}
                              className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-[80%] text-[#000] text-[12px] xl:text-[14px]"
                            >
                              <option>
                                {selectedWeeks?.["Sun"]
                                  ? selectedWeeks["Sun"]
                                  : "No Week Off for Sunday"}
                              </option>
                            </select>
                          </td>
                        ) : (
                          <td className="flex items-center pr-5">
                            <Select
                              options={options}
                              isMulti
                              placeholder="Select Shift"
                              vvalue={Shift.shiftSeven}
                              onChange={(selected) =>
                                setShift({ ...Shift, shiftSeven: selected })
                              }
                              onMenuOpen={() =>
                                selectedShift?.length === 0 && openModal1()
                              }
                              className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-[94%] text-[#000] text-[12px] xl:text-[14px]"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: "40px",
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: "#e5e7eb",
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: "#000",
                                }),
                                multiValueRemove: (base) => ({
                                  ...base,
                                  color: "#ff0000",
                                  cursor: "pointer",
                                }),
                              }}
                            />
                            <button className="bg-[#27004a] ml-4 rounded-full">
                              <AddIcon
                                className="text-white"
                                onClick={openModal1}
                              />
                            </button>
                          </td>
                        )}
                      </div>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
                <button className="first-btn" onClick={closeModal}>
                  Cancel
                </button>
                <button
                  disabled={fixedShiftSubmission}
                  className={` ${fixedShiftSubmission ? "second-btn-disabled" : "second-btn"
                    }`}
                  onClick={submitFixedShifts}
                >
                  Confirm
                </button>
              </div>
            </div>
          </TabPanel>

          <TabPanel>
            <div className="first-panel">
              <div className="flex justify-center items-center gap-4 pr-[10px] pl-[10px]">
                <h2 className="text-[14px] whitespace-nowrap">Select Month</h2>
                <input
                  type="month"
                  value={`${selectedMonth.getFullYear()}-${String(
                    selectedMonth.getMonth() + 1
                  ).padStart(2, "0")}`}
                  onChange={handleMonthChange}
                  className="bg-[#F4F5F9] p-[6px] border rounded-md focus-visible:outline-none w-[100%] lg:w-[240px] text-sm"
                />
              </div>
              <div className="flex justify-center items-center gap-4 mt-[7px]">
                <h2 className="text-[14px]">Select All</h2>
                <div className="pl-[26px]">
                  <Select
                    // isDisabled={updateWeekOff.weekOff}
                    options={options}
                    isMulti
                    placeholder="Select Shift"
                    value={
                      flexibleDay?.length > 0 ? flexibleDay[0]?.shifts : []
                    }
                    onChange={(selected) => {
                      setFlexibleDay(
                        dateTime.map((currentDay) => {
                          const date = new Date(
                            selectedMonth.getFullYear(),
                            selectedMonth.getMonth(),
                            currentDay
                          );
                          return {
                            day: new Date(date).toISOString(),
                            shifts: selected,
                            weekoff: false,
                          };
                        })
                      );
                    }}
                    onMenuOpen={() =>
                      selectedShift?.length === 0 && openModal1()
                    }
                    className="bg-[#fff] p-[6px] rounded-md focus-visible:outline-none w-[100%] lg:w-[250px] text-sm"
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: "40px",
                        // maxHeight: '30px',
                        // overflow: "scroll",
                        // scrollBehavior: "smooth",
                        // scrollbarWidth: "none",
                        // overflowX: "hidden",
                      }),
                      multiValue: (base) => ({
                        ...base,
                        backgroundColor: "#e5e7eb",
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        color: "#000",
                        // height: '30px',
                        // display:"flex",
                        // flexDirection:"column",
                        // justifyContent:"center",
                        // alignItems: 'center',
                      }),
                      multiValueRemove: (base) => ({
                        ...base,
                        color: "#ff0000",
                        cursor: "pointer",
                      }),
                    }}
                  />
                </div>
              </div>
              <div className="h-[50vh] overflow-y-scroll">
                <table className="w-full">
                  <thead className="border-[#000] border-b">
                    <tr>
                      <th className="p-3 font-medium text-[13px]">Day</th>
                      <th className="flex items-center gap-[7px] p-3 w-[45px] font-medium text-[13px]">
                        Weekoff{" "}
                        <input type="checkbox" onChange={handleWeekoffToggle} />
                      </th>
                      <th className="p-3 pl-[8px] font-medium text-[13px] text-center">
                        Shifts
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dateTime?.map((day) => {
                      const date = new Date(
                        selectedMonth.getFullYear(),
                        selectedMonth.getMonth(),
                        day
                      );
                      const isSunday = date.getDay() === 0;
                      const updateWeekOff = flexibleDay.find(
                        (item) => item.day === date.toISOString()
                      );

                      return (
                        <tr key={date}>
                          <td className="font-normal text-[12px] text-center">
                            {`${date.toLocaleDateString("en-US", {
                              month: "short",
                            })} ${String(day).padStart(1, "0")} | ${getDayName(
                              date
                            )}`}
                          </td>
                          <td className="p-3 text-center">
                            <input
                              type="checkbox"
                              checked={updateWeekOff?.weekOff ?? false}
                              onChange={(e) => {
                                if (updateWeekOff) {
                                  setFlexibleDay([
                                    ...flexibleDay.filter(
                                      (item) => item.day !== date.toISOString()
                                    ),
                                    {
                                      ...updateWeekOff,
                                      weekOff: !updateWeekOff.weekOff,
                                    },
                                  ]);
                                } else {
                                  setFlexibleDay([
                                    ...flexibleDay,
                                    {
                                      day: date.toISOString(),
                                      weekOff: true,
                                      shifts: [],
                                    },
                                  ]);
                                }
                              }}
                            />
                          </td>
                          <td className="pr-5">
                            {updateWeekOff?.weekOff ? (
                              <div className="bg-[#F4F5F9] mt-1 mr-[0px] ml-[7px] p-[5px] border border-1 rounded-md focus:outline-none w-full text-[#000] text-[12px] xl:text-[14px]">
                                Week Off
                              </div>
                            ) : (
                              <Select
                                isDisabled={updateWeekOff?.weekOff}
                                options={options}
                                isMulti
                                placeholder="Select Shift"
                                value={updateWeekOff?.shifts || []}
                                onChange={(selected) => {
                                  if (updateWeekOff) {
                                    setFlexibleDay([
                                      ...flexibleDay.filter(
                                        (item) =>
                                          item.day !== date.toISOString()
                                      ),
                                      {
                                        day: date.toISOString(),
                                        weekOff: false,
                                        shifts: selected,
                                      },
                                    ]);
                                  } else {
                                    setFlexibleDay([
                                      ...flexibleDay,
                                      {
                                        day: date.toISOString(),
                                        weekOff: false,
                                        shifts: selected,
                                      },
                                    ]);
                                  }
                                }}
                                className="mt-1 mr-[0px] ml-[7px] p-[5px] rounded-md focus:outline-none w-full text-[#000] text-[12px] xl:text-[14px]"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "40px",
                                  }),
                                  multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: "#e5e7eb",
                                  }),
                                  multiValueLabel: (base) => ({
                                    ...base,
                                    color: "#000",
                                  }),
                                  multiValueRemove: (base) => ({
                                    ...base,
                                    color: "#ff0000",
                                    cursor: "pointer",
                                  }),
                                }}
                              />
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
                <button className="first-btn" onClick={closeModal}>
                  Cancel
                </button>
                <button
                  onClick={createFlexibleShift}
                  disabled={isFlexibleShiftCreating}
                  className={
                    isFlexibleShiftCreating
                      ? "second-btn-disabled"
                      : "second-btn"
                  }
                >
                  Update Work Timings for All Staff
                </button>
              </div>
            </div>
          </TabPanel>
        </Tabs>
      </Modal>

      <Modal
        isOpen={modalIsOpen1}
        onAfterOpen={afterOpenModal1}
        onRequestClose={closeModal1}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <div className="flex flex-col h-full max-h-[50vh]">
          <div className="relative border-b">
            <h2
              ref={(_subtitle) => (subtitle = _subtitle)}
              className="p-3 border-b-1 text-[13px] xl:text-[15px]"
            >
              Monday - Shifts
            </h2>
            <button
              onClick={closeModal1}
              className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
            >
              <CloseIcon className="text-white" />
            </button>
          </div>
          <div className="max-h-[20vh] overflow-y-auto">
            {/* {
                        shiftDetails?.map((op,index)=>{
                            return  <div className='flex justify-between items-center px-3 py-3 border-b'>
                            <h3 className='text-[13px]'>{op.shiftName} | {op.shiftStartTime} - {op.shiftEndTime} </h3>
                            <input type="checkbox" value={selectedShift.filter(s=>s.id == op.id)[0]??false} onChange={(e)=>setSelectedShift((prev)=>{
                                return [...prev , ...shiftDetails?.filter((opt)=>opt.id===op.id)]
                            })}/>
                        </div>
                        })
                    } */}

            <div className="flex flex-col flex-1">
              {shiftDetails?.map((op) => (
                <div
                  key={op.id}
                  className="flex justify-between items-center px-3 py-3 border-b"
                >
                  <h3 className="text-[13px]">
                    {op.shiftName} | {op.shiftStartTime} - {op.shiftEndTime}
                  </h3>
                  <input
                    type="checkbox"
                    checked={isSelected(op.id)}
                    onChange={() => handleCheckboxChange(op)}
                  />
                </div>
              ))}
            </div>
          </div>
          <Link
            to=""
            className="flex items-center mt-1 p-4 w-full font-medium text-[#8A25B0] text-[16px] xl:text-[15px]"
            onClick={openModal2}
          >
            <AddIcon /> Add Shift
          </Link>
          <br />
          <div className="flex justify-end items-center gap-[10px] pr-4 pb-3 text-end">
            <button className="first-btn" onClick={closeModal1}>
              Cancel
            </button>
            <button className="second-btn" onClick={closeModal1}>
              Confirm
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={modalIsOpen2}
        onAfterOpen={afterOpenModal2}
        onRequestClose={closeModal2}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <div className="flex flex-col h-full max-h-[90vh]">
          <div className="relative border-b">
            <h2
              ref={(_subtitle) => (subtitle = _subtitle)}
              className="p-3 border-b-1 text-[13px] xl:text-[15px]"
            >
              Add New Shifts
            </h2>
            <button
              onClick={closeModal2}
              className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
            >
              <CloseIcon className="text-white" />
            </button>
          </div>
          <div className="flex flex-col flex-1 overflow-y-auto">
            <div className="p-[10px] border border-t modal-field">
              <label className="font-medium text-[13px] xl:text-[14px]">
                Shift Name
              </label>
              <br />
              <input
                onChange={(e) => setShiftName(e.target.value)}
                type="text"
                className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              />
              <br />
              <label className="font-medium text-[13px] xl:text-[14px]">
                Shift Start Time
              </label>
              <br />
              {/* <input
                onChange={(e) => {
                  setShiftStartTime(handleTimeChange(e.target.value));
                }}
                type="time"
                className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              /> */}

              <input
                onFocus={(e) => e.target.showPicker()} // This forces the time picker to open
                onChange={(e) =>
                  setShiftStartTime(handleTimeChange(e.target.value))
                }
                type="time"
                className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer"
              />

              <br />
              <label className="font-medium text-[13px] xl:text-[14px]">
                Can Punch In
              </label>
              <br />
              <div className="flex justify-between">
                <Tabs className="w-full">
                  <TabList className="flex justify-between gap-[20px] w-full">
                    <Tab className="w-[48%]">
                      <div className="flex items-center gap-[10px] mt-1 mb-[10px] p-[8px] pl-[15px] border border-1 rounded-md focus:outline-none w-full placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer">
                        <input
                          value="ANYTIME"
                          onChange={(e) => setPunchInType(e.target.value)}
                          type="radio"
                          id="anytime"
                          name="select-timing"
                        />
                        <label
                          for="anytime"
                          className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                        >
                          Anytime
                        </label>
                        <br />
                      </div>
                    </Tab>
                    <Tab className="w-[48%]">
                      <div className="flex items-center gap-[10px] mt-1 mb-[10px] p-[8px] pl-[15px] border border-1 rounded-md focus:outline-none w-full placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer">
                        <input
                          type="radio"
                          value="ADDLIMIT"
                          onChange={(e) => setPunchInType(e.target.value)}
                          id="limit"
                          name="select-timing"
                        />
                        <label
                          for="limit"
                          className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                        >
                          Add Limit
                        </label>
                        <br />
                      </div>
                    </Tab>
                  </TabList>

                  <TabPanel></TabPanel>

                  <TabPanel>
                    <label className="font-medium text-[13px] xl:text-[14px]">
                      Allow Punch In
                    </label>
                    <br />
                    <div className="flex lg:flex-row xl:flex-row flex-col gap-[3px] xl:gap-[30px]">
                      <div className="flex items-center gap-2">
                        <input
                          type="number"
                          onChange={(e) =>
                            setAllowPunchInHour(Number(e.target.value))
                          }
                          className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[40px] placeholder:font-font-normal text-[#000] text-[14px]"
                        />
                        <label
                          for="limit"
                          className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                        >
                          Hours
                        </label>
                        <br />
                      </div>

                      <div className="flex items-center gap-2">
                        <input
                          type="number"
                          onChange={(e) =>
                            setAllowPunchInMinutes(Number(e.target.value))
                          }
                          className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100px] placeholder:font-font-normal text-[#000] text-[14px]"
                        />
                        <label
                          for="limit"
                          className="flex font-medium text-[13px] xl:text-[14px] whitespace-nowrap cursor-pointer"
                        >
                          Minutes{" "}
                          <span className="pl-[10px] xl:pl-[15px]">
                            Before Shift Start Time
                          </span>
                        </label>
                        <br />
                      </div>
                    </div>
                  </TabPanel>
                </Tabs>
              </div>

              <label className="font-medium text-[13px] xl:text-[14px]">
                Shift End Time
              </label>
              <br />

              {/* <input
                type="time"
                onChange={(e) =>
                  setShiftEndTime(handleTimeChange(e.target.value))
                }
                className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              /> */}
              <input
                type="time"
                onFocus={(e) => e.target.showPicker()} // Opens the time picker on focus
                onChange={(e) =>
                  setShiftEndTime(handleTimeChange(e.target.value))
                }
                className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer"
              />

              <label className="font-medium text-[13px] xl:text-[14px]">
                Can Punch Out
              </label>
              <br />
              <div className="">
                <Tabs className="w-full">
                  <TabList className="flex justify-between gap-[20px] w-full">
                    <Tab className="w-[48%]">
                      <div className="flex items-center gap-[10px] mt-1 mb-[10px] p-[8px] pl-[15px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer">
                        <input
                          type="radio"
                          value="ANYTIME"
                          onChange={(e) => setPunchOutType(e.target.value)}
                          id="anytime1"
                          name="punching-timing"
                        />
                        <label
                          className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                          for="anytime1"
                        >
                          Anytime
                        </label>
                        <br />
                      </div>
                    </Tab>
                    <Tab className="w-[48%]">
                      <div className="flex items-center gap-[10px] mt-1 mb-[10px] p-[8px] pl-[15px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer">
                        <input
                          value="ADDLIMIT"
                          onChange={(e) => setPunchOutType(e.target.value)}
                          type="radio"
                          id="limit1"
                          name="punching-timing"
                        />
                        <label
                          className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                          for="limit1"
                        >
                          Add Limit
                        </label>
                        <br />
                      </div>
                    </Tab>
                  </TabList>

                  <TabPanel></TabPanel>
                  <TabPanel>
                    <label className="font-medium text-[14px]">
                      Allow Punch Out
                    </label>
                    <br />
                    <div className="flex lg:flex-row xl:flex-row flex-col gap-[3px] xl:gap-[30px]">
                      <div className="flex items-center gap-2">
                        <input
                          type="number"
                          onChange={(e) =>
                            setAllowPunchOutHour(Number(e.target.value))
                          }
                          className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[40px] placeholder:font-font-normal text-[#000] text-[14px]"
                        />
                        <label
                          for="limit"
                          className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
                        >
                          Hours
                        </label>
                        <br />
                      </div>

                      <div className="flex items-center gap-2">
                        <input
                          type="number"
                          onChange={(e) =>
                            setAllowPunchOutMinutes(Number(e.target.value))
                          }
                          className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100px] placeholder:font-font-normal text-[#000] text-[14px]"
                        />
                        <label
                          for="limit"
                          className="flex font-medium text-[13px] xl:text-[14px] whitespace-nowrap cursor-pointer"
                        >
                          Minutes{" "}
                          <span className="pl-[10px] xl:pl-[15px]">
                            Before Shift Start Time
                          </span>
                        </label>
                        <br />
                      </div>
                    </div>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>
          <div className="flex justify-end gap-[10px] bg-white mt-auto p-3 border-t">
            <button className="first-btn" onClick={closeModal2}>
              Cancel
            </button>
            <button
              disabled={isShiftSubmission}
              className={` ${isShiftSubmission ? "second-btn-disabled" : "second-btn"
                } `}
              onClick={submitShift}
            >
              Confirm
            </button>
          </div>
        </div>
      </Modal>

      {/* onclick star timing ---- time modal */}
      <Modal
        isOpen={modalIsOpen3}
        onAfterOpen={afterOpenModal3}
        onRequestClose={closeModal3}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="mb-4 p-3 border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]"
        >
          Select Time
        </h2>
        <button
          onClick={closeModal3}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>

        <div className="">
          <table className="table-timing p-[10px] w-full">
            <tbody className="flex justify-center gap-[12px] w-full">
              <tr className="flex flex-col w-[100px] h-[205px] overflow-scroll overflow-x-hidden">
                <td className="">00</td>
                <td>01</td>
                <td>02</td>
                <td>03</td>
                <td>04</td>
                <td>05</td>
                <td>06</td>
                <td>07</td>
              </tr>
              <tr className="flex flex-col w-[100px] h-[205px] overflow-scroll overflow-x-hidden">
                <td>00</td>
                <td>01</td>
                <td>02</td>
                <td>03</td>
                <td>04</td>
                <td>05</td>
                <td>06</td>
                <td>07</td>
              </tr>
              <tr className="flex flex-col w-[100px]">
                <td>AM</td>
                <td>PM</td>
              </tr>
            </tbody>
            <h3 className="pt-[25px] pb-[25px] text-[13px] xl:text-[14px] text-center">
              Selected Time: 12:00 PM
            </h3>
          </table>

          <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
            <button className="first-btn" onClick={closeModal3}>
              Cancel
            </button>
            <button className="second-btn">Okay</button>
          </div>
        </div>
      </Modal>

      {/* onclick star timing ---- time modal */}

      {/* onclick end timing ----time modal */}

      <Modal
        isOpen={modalIsOpen4}
        onAfterOpen={afterOpenModal4}
        onRequestClose={closeModal4}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="mb-4 p-3 border border-t-0 border-r-0 border-b border-l-0"
        >
          Select Time
        </h2>
        <button
          onClick={closeModal4}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <div className="">
          <table className="table-timing p-[10px] w-full">
            <tbody className="flex justify-center gap-[12px] w-full">
              <tr className="flex flex-col w-[100px] h-[205px] overflow-scroll overflow-x-hidden">
                <td className="">00</td>
                <td>01</td>
                <td>02</td>
                <td>03</td>
                <td>04</td>
                <td>05</td>
                <td>06</td>
                <td>07</td>
              </tr>
              <tr className="flex flex-col w-[100px] h-[205px] overflow-scroll overflow-x-hidden">
                <td>00</td>
                <td>01</td>
                <td>02</td>
                <td>03</td>
                <td>04</td>
                <td>05</td>
                <td>06</td>
                <td>07</td>
              </tr>
              <tr className="flex flex-col w-[100px]">
                <td>AM</td>
                <td>PM</td>
              </tr>
            </tbody>
            <h3 className="pt-[25px] pb-[25px] text-center">
              Selected Time: 12:00 PM
            </h3>
          </table>

          <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
            <button className="first-btn" onClick={closeModal4}>
              Cancel
            </button>
            <button className="second-btn">Okay</button>
          </div>
        </div>
      </Modal>

      {/* onclick end timing modal */}

      {/* onclick update attendance modal */}
      <Modal
        isOpen={modalIsOpen5}
        onAfterOpen={afterOpenModal5}
        onRequestClose={closeModal5}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="p-3 border-[#000] border-b text-[14px]"
        >
          Bulk Update Work Timings for All Staff
        </h2>
        <button
          onClick={closeModal5}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <div className="pb-2">
          <div className="flex justify-between items-center bg-[#F0F6FE] p-[10px] pl-[20px] text-[13px] xl:text-[14px]">
            <h4 className="m-0">Allow punch in from Staff App</h4>
            <div className="flex items-center">
              <div
                onClick={handleToggle}
                className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${isOn ? "bg-[#8A25B0]" : "bg-gray-300"
                  }`}
              >
                <div
                  className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${isOn ? "translate-x-6" : "translate-x-0"
                    }`}
                ></div>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center p-[10px] pl-[20px] border border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
            <div className="flex items-center gap-[12px]">
              <img src={selfie} className="w-[25px] h-[25px]" />
              <h4 className="m-0">Selfie Attendance</h4>
            </div>
            <div className="flex items-center">
              <div
                onClick={selfieAttendance}
                className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${isOnSelfie ? "bg-[#8A25B0]" : "bg-gray-300"
                  }`}
              >
                <div
                  className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${isOnSelfie ? "translate-x-6" : "translate-x-0"
                    }`}
                ></div>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
            <div className="flex items-center gap-[12px]">
              <img src={qr} className="w-[25px] h-[25px]" />
              <h4 className="m-0">QR Attendance</h4>
            </div>
            <div className="flex items-center">
              <div
                onClick={qrAttendance}
                className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${qrCode ? "bg-[#8A25B0]" : "bg-gray-300"
                  }`}
              >
                <div
                  className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${qrCode ? "translate-x-6" : "translate-x-0"
                    }`}
                ></div>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
            <div className="flex items-center gap-[12px]">
              <img src={gps} className="w-[25px] h-[25px]" />
              <h4 className="m-0">GPS Attendance</h4>
            </div>
            <div className="flex items-center">
              <div
                onClick={gpsAttendance}
                className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${gpsCode ? "bg-[#8A25B0]" : "bg-gray-300"
                  }`}
              >
                <div
                  className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${gpsCode ? "translate-x-6" : "translate-x-0"
                    }`}
                ></div>
              </div>
            </div>
          </div>

          <div className="p-4 pl-5 border border-t-0 border-r-0 border-b border-l-0">
            <label className="font-medium text-[13px] xl:text-[14px]">
              Mark Attendance From
            </label>

            <div className="flex gap-[12px] pt-3">
              <div className="flex items-center gap-[10px] pt-2 pr-3 pb-2 pl-3 border rounded-md">
                <input
                  onChange={(e) => {
                    setMarkAttendanceOffice(e.target.value);
                  }}
                  type="radio"
                  id="foroffice"
                  name="office"
                  value="Office"
                />
                <label for="foroffice" className="text-[13px] xl:text-[14px]">
                  Office
                </label>
                <br />
              </div>
              <div className="flex items-center gap-[10px] pt-2 pr-3 pb-2 pl-3 border rounded-md">
                <input
                  onChange={(e) => {
                    setMarkAttendanceOffice(e.target.value);
                  }}
                  type="radio"
                  id="anywhere"
                  name="office"
                  value="Anywhere"
                />
                <label for="anywhere" className="text-[13px] xl:text-[14px]">
                  Anywhere
                </label>
                <br />
              </div>
            </div>
          </div>

          <div className="flex items-center gap-[14px] p-4 pl-5 border border-t-0 border-r-0 border-b border-l-0">
            <img src={biometric} />
            <div>
              <label className="font-medium text-[13px] xl:text-[14px]">
                Biometric Devices
              </label>
              <br />
              <Link
                to="/biometric"
                className="text-[#8A25B0] text-[13px] xl:text-[14px] decoration-1 underline"
              >
                Manage biometric devices
              </Link>
            </div>
          </div>

          <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
            <button className="first-btn" onClick={closeModal5}>
              Cancel
            </button>
            <button
              disabled={isUpdatingAttendeceMode}
              className={
                isUpdatingAttendeceMode ? "second-btn-disabled" : "second-btn"
              }
              onClick={updateDetails}
            >
              Update Attendance Modes for All Staff
            </button>
          </div>
        </div>
      </Modal>

      {/* onclick update attendance modal */}

      {/* when onclick update attendance modes for all staff */}

      <Modal
        isOpen={modalIsOpen6}
        onAfterOpen={afterOpenModal6}
        onRequestClose={closeModal6}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="p-3 border-[#000] border-b text-[14px]"
        >
          Bulk Update Work Timings for All Staff
        </h2>
        <button
          onClick={closeModal6}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <div className="flex flex-col justify-center items-center gap-[10px] pt-[20px] pb-[20px]">
          <img src={rightimg} className="w-[65px]" />
          <h3 className="text-center">
            You have Successfully updated attendance modes
          </h3>
          <button className="second-btn" onClick={closeModal6}>
            Okay
          </button>
        </div>
      </Modal>

      {/* when onclick update attendance modes for all staff */}

      {/* onclick update automation rules */}
      <Modal
        isOpen={modalIsOpen7}
        onAfterOpen={afterOpenModal7}
        onRequestClose={closeModal7}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="p-3 border-[#000] border-b text-[14px]"
        >
          Bulk Update Automation Rules for All Staff
        </h2>
        <button
          onClick={closeModal7}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <div className="pb-2">
          <div className="flex justify-between items-center p-[10px] pl-[20px] border border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
            <div className="flex items-center gap-[12px]">
              <img src={selfie} className="w-[25px] h-[25px]" />
              <h4 className="m-0">Auto Present at day start</h4>
            </div>
            <div className="flex items-center">
              <div
                onClick={autoPresentFn}
                className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${autoPresent ? "bg-[#8A25B0]" : "bg-gray-300"
                  }`}
              >
                <div
                  className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${autoPresent ? "translate-x-6" : "translate-x-0"
                    }`}
                ></div>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
            <div className="flex items-center gap-[12px]">
              <img src={qr} className="w-[25px] h-[25px]" />
              <h4 className="m-0">Present on Punch In</h4>
            </div>
            <div className="flex items-center">
              <div
                onClick={PresentPunchFn}
                className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${presentPunch ? "bg-[#8A25B0]" : "bg-gray-300"
                  }`}
              >
                <div
                  className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${presentPunch ? "translate-x-6" : "translate-x-0"
                    }`}
                ></div>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
            <div className="flex items-center gap-[12px]">
              <img src={gps} className="w-[25px] h-[25px]" />
              <h4 className="m-0">Auto half day if late by</h4>
            </div>
            <div className="flex items-center">
              <button className="first-btn" onClick={openModal16}>
                {confirmedTime
                  ? `${confirmedTime?.hours} hours, ${confirmedTime?.minutes} minutes`
                  : "Not Set"}
              </button>
            </div>
          </div>

          <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
            <div className="flex items-center gap-[12px]">
              <img src={gps} className="w-[25px] h-[25px]" />
              <h4 className="m-0">Mandatory half day hours</h4>
            </div>
            <div className="flex items-center">
              <button className="first-btn" onClick={openModal17}>
                {savedDuration
                  ? `${savedDuration?.hrs} hours, ${savedDuration?.mins} minutes`
                  : "Not Set"}
              </button>
            </div>
          </div>

          <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
            <div className="flex items-center gap-[12px]">
              <img src={gps} className="w-[25px] h-[25px]" />
              <h4 className="m-0">Mandatory full day hours</h4>
            </div>
            <div className="flex items-center">
              <button className="first-btn" onClick={openModal18}>
                {confirmedSelection
                  ? `${confirmedSelection?.hourValue} hours, ${confirmedSelection?.minuteValue} minutes`
                  : "Not Set"}
              </button>
            </div>
          </div>

          <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3">
            <button className="first-btn" onClick={closeModal7}>
              Cancel
            </button>
            <button
              disabled={isUpdatingAutomationDetails}
              className={`${isUpdatingAutomationDetails
                ? "second-btn-disabled"
                : "second-btn"
                }`}
              onClick={updateAutomationDetail}
            >
              Update Automation Rules for All Staff
            </button>
          </div>
        </div>
      </Modal>

      {/* onclick update automation rules */}

      {/* onclick autohalf day minutes  button */}

      <Modal
        isOpen={modalIsOpen16}
        onAfterOpen={afterOpenModal16}
        onRequestClose={closeModal16}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="p-3 border-[#000] border-b text-[14px]"
        >
          Auto half day if late by
        </h2>
        <button
          onClick={closeModal16}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <div className="p-[12px] pb-2">
          <label className="font-medium text-[13px] xl:text-[14px]">
            Select Duration
          </label>

          <div className="flex lg:flex-row xl:flex-row flex-col gap-[3px] xl:gap-[30px]">
            <div className="flex items-center gap-2">
              <input
                type="number"
                onChange={handleChange}
                value={time.hours}
                name="hours"
                className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[40px] placeholder:font-font-normal text-[#000] text-[14px]"
              />
              <label
                htmlFor="limit"
                className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
              >
                Hours
              </label>
              <br />
            </div>
            <div className="flex items-center gap-2">
              <input
                type="number"
                onChange={handleChange}
                value={time.minutes}
                name="minutes"
                className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100px] placeholder:font-font-normal text-[#000] text-[14px]"
              />
              <label
                htmlFor="limit"
                className="flex font-medium text-[13px] xl:text-[14px] whitespace-nowrap cursor-pointer"
              >
                Minutes
              </label>
              <br />
            </div>
          </div>

          <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3">
            <button className="first-btn" onClick={closeModal16}>
              Turn Off
            </button>
            <button className="second-btn" onClick={handleConfirm}>
              Confirm
            </button>
          </div>
        </div>
      </Modal>

      {/* onclick autohalf day minutes  button */}

      {/* onclick mandatory half day minutes  button */}

      <Modal
        isOpen={modalIsOpen17}
        onAfterOpen={afterOpenModal17}
        onRequestClose={closeModal17}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="p-3 border-[#000] border-b text-[14px]"
        >
          Mandatory half day hours
        </h2>
        <button
          onClick={closeModal17}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <div className="p-[12px] pb-2">
          <label className="font-medium text-[13px] xl:text-[14px]">
            Select Duration
          </label>

          <div className="flex lg:flex-row xl:flex-row flex-col gap-[3px] xl:gap-[30px]">
            <div className="flex items-center gap-2">
              <input
                type="number"
                onChange={handleDurationChange}
                value={duration.hrs}
                name="hrs"
                className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[40px] placeholder:font-font-normal text-[#000] text-[14px]"
              />
              <label
                htmlFor="limit"
                className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
              >
                Hours
              </label>
              <br />
            </div>
            <div className="flex items-center gap-2">
              <input
                type="number"
                onChange={handleDurationChange}
                value={duration.mins}
                name="mins"
                className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100px] placeholder:font-font-normal text-[#000] text-[14px]"
              />
              <label
                htmlFor="limit"
                className="flex font-medium text-[13px] xl:text-[14px] whitespace-nowrap cursor-pointer"
              >
                Minutes
              </label>
              <br />
            </div>
          </div>

          <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3">
            <button className="first-btn" onClick={closeModal17}>
              Turn Off
            </button>
            <button className="second-btn" onClick={handleSaveDuration}>
              Confirm
            </button>
          </div>
        </div>
      </Modal>

      {/* onclick mandatory half day minutes  button */}

      {/* onclick mandatory full day minutes  button */}

      <Modal
        isOpen={modalIsOpen18}
        onAfterOpen={afterOpenModal18}
        onRequestClose={closeModal18}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="p-3 border-[#000] border-b text-[14px]"
        >
          Mandatory Full day hours
        </h2>
        <button
          onClick={closeModal18}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <div className="p-[12px] pb-2">
          <label className="font-medium text-[13px] xl:text-[14px]">
            Select Duration
          </label>

          <div className="flex lg:flex-row xl:flex-row flex-col gap-[3px] xl:gap-[30px]">
            <div className="flex items-center gap-2">
              <input
                type="number"
                onChange={handleTimeChangeSet}
                value={selectedTime.hourValue}
                name="hourValue"
                className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[40px] placeholder:font-font-normal text-[#000] text-[14px]"
              />
              <label
                htmlFor="hourValue"
                className="font-medium text-[13px] xl:text-[14px] cursor-pointer"
              >
                Hours
              </label>
              <br />
            </div>
            <div className="flex items-center gap-2">
              <input
                type="number"
                onChange={handleTimeChangeSet}
                value={selectedTime.minuteValue}
                name="minuteValue"
                className="mt-1 mb-[10px] p-[5px] border border-1 rounded-md focus:outline-none w-[100px] placeholder:font-font-normal text-[#000] text-[14px]"
              />
              <label
                htmlFor="minuteValue"
                className="flex font-medium text-[13px] xl:text-[14px] whitespace-nowrap cursor-pointer"
              >
                Minutes
              </label>
              <br />
            </div>
          </div>

          <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3">
            <button className="first-btn" onClick={closeModal18}>
              Turn Off
            </button>
            <button className="second-btn" onClick={handleSaveSelection}>
              Confirm
            </button>
          </div>
        </div>
      </Modal>

      {/* onclick mandatory full day minutes  button */}

      {/* when onclick update attendance mods for aall staff successfull msg */}
      <Modal
        isOpen={modalIsOpen8}
        onAfterOpen={afterOpenModal8}
        onRequestClose={closeModal8}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="p-3 border-[#000] border-b text-[14px]"
        >
          Bulk Update Work Timings for All Staff
        </h2>
        <button
          onClick={closeModal8}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <div className="flex flex-col justify-center items-center gap-[10px] pt-[20px] pb-[20px]">
          <img src={rightimg} className="w-[65px]" />
          <h3 className="text-center">
            You have Successfully updated attendance modes
          </h3>
          <button className="second-btn" onClick={closeModal8}>
            Okay
          </button>
        </div>
      </Modal>
      {/* when onclick update attendance mods for aall staff successfull msg */}

      <Modal
        isOpen={modalIsOpen22}
        onAfterOpen={afterOpenModal22}
        onRequestClose={closeModal22}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="p-3 border-b-1 text-[13px] xl:text-[15px]"
        >
          Week Offs
        </h2>
        <button
          onClick={closeModal22}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <div className="">
          <div className="p-3">
            <div className="flex justify-between items-center py-2 border-b">
              <h4>All Weeks Off</h4>
              <input
                type="checkbox"
                checked={allWeeksSelected}
                onChange={handleAllWeeksToggle}
              />
            </div>
            {Object.keys(weeks).map((week, index) => (
              <div
                key={index}
                className="flex justify-between items-center py-2 border-b"
              >
                <h4>{`${index + 1}${index === 0
                  ? "st"
                  : index === 1
                    ? "nd"
                    : index === 2
                      ? "rd"
                      : "th"
                  } Week`}</h4>
                <input
                  type="checkbox"
                  checked={weeks[week]}
                  onChange={() => handleWeekToggle(week)}
                />
              </div>
            ))}
            <div className="flex justify-end items-center gap-[10px] py-2 pr-4 pb-3 text-end">
              <button className="first-btn" onClick={closeModal22}>
                Cancel
              </button>
              <button className="second-btn" onClick={handleConfirm2}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AttendanceTab;
